import { clsx } from 'clsx';
import { useNode } from './useNode';
import useFeatureFlags from 'hooks/useFeatureFlags';

export function NodeName() {
  const { depth, node } = useNode();
  const { isFeatureFlagEnabled } = useFeatureFlags();
  const isNestedAccountsFeatureEnabled =
    isFeatureFlagEnabled('nested_accounts');

  const classes = clsx(
    'flex flex-col',
    !node.node_level_name && 'py-2',
    depth === 1 && 'font-semibold'
  );

  return node.type === 'Classroom' ? (
    <div className="flex flex-col">
      <span className="text-xs font-semibold">CLASSROOM</span>
      <span className="text-base">{node.name}</span>
    </div>
  ) : (
    <>
      <div className={classes}>
        {node.node_level_name && (
          <span className="text-xs font-semibold uppercase">
            {node.node_level_name}
          </span>
        )}

        <span className="text-base">{node.name}</span>
      </div>
      {isNestedAccountsFeatureEnabled && node.type === 'Account' && (
        <span className="ml-auto mr-3 text-xs text-gray-600 pl-1 pr-1 border border-gray-200 rounded">
          Account
        </span>
      )}
    </>
  );
}
